import { useState, useRef, useEffect } from "react";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import classes from "./BankRecon.module.css";
import {
  Calendar,
  Repeat,
  RefreshCcw,
  Upload,
  Download,
  CheckCircle,
  Clock,
  MousePointerClick,
} from "lucide-react";
import greentick from "../../Assets/greentick.svg";
import bluenote from "../../Assets/bluenote.svg";
import pending from "../../Assets/pendingyellow.svg";
import dollaz from "../../Assets/dollars.svg";
import Transactions from "./Transactions";
import Footer from "../../Components/Footer/Footer";

const BankRecon = () => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Current Month");
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarClick = (e) => {
    e.stopPropagation();
    inputRef.current.showPicker(); // shows native picker in modern browsers
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    const monthName = new Date(e.target.value).toLocaleString("default", {
      month: "long",
    });
    setSelectedMonth(`${monthName} ${year}`);
  };
  return (
    <div className={classes.bodyxyz}>
      <HeaderNav />
      <section className={classes.bankbody}>
        <div className={classes.actions}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>
            Product & Services
          </button>
        </div>

        <header className={classes.header}>
          <div className={classes.header1}>
            <h2 className={classes.Title}>Receipts</h2>
            <h1 className={classes.Titles}>
              Track and manage all incoming payments from customers.
            </h1>
          </div>
          <div className={classes.header2}>
            <div className={classes.wrapper} ref={wrapperRef}>
              <div
                className={classes.combobox}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <Calendar
                  className={classes.icon}
                  onClick={handleCalendarClick}
                />
                <span className={classes.label}>{selectedMonth}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={classes.chevron}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 011.1 1.02l-4.25 4.65a.75.75 0 01-1.1 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
                <input
                  type="month"
                  ref={inputRef}
                  onChange={handleMonthChange}
                  className={classes.hiddenInput}
                />
              </div>
            </div>
          </div>
        </header>
      </section>
      <section className={classes.cardsect}>
        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>
                  Matched Items{" "}
                  <img src={greentick} className={classes.sideicon} alt="" />
                </p>
                <p className={classes.kdptg1}>2</p>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>
                  Ledger Balance{" "}
                  <img src={bluenote} className={classes.sideicon} alt="" />
                </p>
                <p className={classes.kdptg2}>-₦100,000.00</p>
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>
                  Pending Match{" "}
                  <img src={pending} className={classes.sideicon} alt="" />
                </p>
                <p className={classes.kdptg3}>3</p>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>
                  Bank Balance{" "}
                  <img src={dollaz} className={classes.sideicon} alt="" />
                </p>
                <p className={classes.kdptg4}>₦78,500.00</p>
                <div className={classes.rvnue}></div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.container_x}>
          <div className={classes.leftGroup}>
            <button className={classes.primaryBtn}>
              <Repeat size={16} />
              Match Selected (0)
            </button>

            <button className={classes.outlineGreen}>
              <RefreshCcw size={16} />
              Auto Match
            </button>

            <button className={classes.outlineDark}>
              <Upload size={16} />
              Import
            </button>

            <button className={classes.outlineDark}>
              <Download size={16} />
              Export
            </button>
          </div>

          <div className={classes.rightGroup}>
            <span className={classes.tagGreen}>
              <CheckCircle size={14} />
              Matched
            </span>

            <span className={classes.tagOrange}>
              <Clock size={14} />
              Pending
            </span>

            <span className={classes.tagBlue}>
              <MousePointerClick size={14} />
              Selected
            </span>
          </div>
        </div>
        <Transactions />
      </section>
      <Footer />
    </div>
  );
};

export default BankRecon;
